/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-07-02 10:35:42
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-02 10:36:02
 */
/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-02-04 09:43:09
 * @LastEditors: voanit
 * @LastEditTime: 2021-03-22 09:52:44
 */
module.exports = {
  title: '拾光伴学集团后台系统',

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: false,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production'
}
